import collapsible from '../../modules/module--collapsible';

export default function() {
    collapsible.add({
        block: '.collapsible-test',
        elToggle: '.collapsible-test__toggle',
        elContent: '.collapsible-test__content',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        speed: 250,
        debug: false
    });
}
